export default "__VITE_ASSET__3k1AFGow__"